import React, { useContext, useEffect, useState } from 'react';
import { FileUploader, message } from '@tencent/spaui';
import { RegistContext } from '../context';

// eslint-disable-next-line react/display-name
export default (props: {
  onDelete: () => void;
  onChange: (data: any, name?: string) => void;
  value?: string;
  maxSize?: number;
  uploadText?: string;
  canDelete?: Boolean;
  reupload?: Boolean;
  check?: () => void;
  flow_key?: string;
  data?: any;
}) => {
  const [uploadValue, setUploadValue] = useState({});
  const { userIdentity } = useContext(RegistContext);
  const handleDelete = () => {
    setUploadValue({});
    props.onDelete();
  };

  useEffect(() => {
    if (!props.value) {
      return;
    }
    setUploadValue({
      url: props.value,
      name: '',
      status: 'success',
    });
  }, [props.value]);

  useEffect(() => {
    if (!props.data) {
      return;
    }
    const { file_url, file_name } = props.data;
    setUploadValue({
      url: file_url,
      name: file_name,
      status: 'success',
    });
  }, [props.data]);

  const fileFilter = (fileInfo: File) => {
    const max = props.maxSize || 10;
    const { size } = fileInfo;

    if (size > max * 1024 * 1024) {
      message.error(`文件大小超过${max}M限制`);
      return false;
    }
    return true;
  };
  return (
    <FileUploader
      name="file"
      url="/isv_service/v1/agency/update_file"
      data={{ flow_key: props.flow_key || userIdentity }}
      value={uploadValue}
      filter={fileFilter}
      onDelete={() => handleDelete()}
      reupload={props.reupload}
      uploadText={props.uploadText || '本地上传'}
      canDelete={!!props.canDelete}
      check={props.check}
      onComplete={(response: any = {}, fileTarget: any) => {
        const { file_url } = response.data?.[0] || {};

        if (response.code === 0) {
          setUploadValue({
            url: file_url,
            name: fileTarget.name,
            status: 'success',
          });
          props.onChange(file_url, fileTarget.name);
        } else {
          setUploadValue({
            name: fileTarget.name,
            status: 'fail',
          });
          message.error(response.msg);
        }
      }}
    />
  );
};
